module.exports = __webpack_public_path__ + "img/bg-type04-pc-mask.44a55aed.png";